import React from "react";
import PropTypes from "prop-types";
import { socialMedia } from "../../config/constants";
import { Icon } from "../icons";
import Side from "../Side/Side";
import { StyledSocialList } from "./Social.styles";

const Social = ({ isHome }) => (
  <Side isHome={isHome} orientation="left">
    <StyledSocialList>
      {socialMedia && socialMedia.length > 0 ? (
        socialMedia.map(({ url, name }, i) => (
          <li key={i}>
            <a
              href={url}
              aria-label={name}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon name={name} />
            </a>
          </li>
        ))
      ) : (
        <li>No social media links available</li>
      )}
    </StyledSocialList>
  </Side>
);

Social.propTypes = {
  isHome: PropTypes.bool,
};

export default Social;
